module.exports = __webpack_public_path__ + "static/media/textediter_underline_active.510a0596.svg";